import React from 'react';
import { observer } from 'mobx-react';
import { analytics } from 'core/analytics';
import { Link } from 'core/routing';

import { Tag } from 'legacyComponents/styled/lib';
import { TagsWrapperNonEdidMode as TagsWrapper } from 'apps/story/styles';

export const TagLinks = observer(({ tags }) => {
  const tagsList = tags.map(tag => (
    <Link name='channel' params={{ channel: tag.name }} key={tag.id}>
      <Tag
        profile
        marginBottom
        onClick={() => {
          analytics.sendEvent('clicked-tag', { name: tag.name });
        }}
      >
        #{tag.name}
      </Tag>
    </Link>
  ));
  return <TagsWrapper>{tagsList}</TagsWrapper>;
});
